import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { ResetPassModal } from '../../../core/modal/reset-pass-modal';
import { ApiUserService } from '../../../core/service/api-user.service';
import { UserValidationService } from '../../../core/service/validations/user-validation.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styles: [
  ]
})
export class ChangePasswordComponent {

  formSubmitAttempt = false;
  resetPassForm: FormGroup;
  resetPassModal!: ResetPassModal;
  hide = true;
  hide_oldPass: boolean = true;
  hide_confirmPass: boolean = true;
  loading = false;

  userID: string;
  sdfd: string = "";

  constructor(
    private userValidation: UserValidationService,
    private fb: FormBuilder,
    private apiUserService: ApiUserService,
    private _config: ConfigService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
   // debugger
    this.userID = data.user_id;
    this.resetPassForm = this.fb.group(this.userValidation.resetPassFormValidation());
    if (!data.showOldPassword) {
      this.resetPassForm.controls['old_password'].clearValidators();
    }
  }

  ngOnInit(): void {
    this.confirmPasswordValidation()
  }


  onResetSubmit() {

    this.formSubmitAttempt = true;

    if (this.resetPassForm.invalid) {
      return;
    }
    this.loading = true;
    this.resetPassModal = { ...this.resetPassForm.value };
    if (!this.data.showOldPassword) {
      delete this.resetPassModal.old_password;
    }

    this.apiUserService.resetPass(this.userID, this.resetPassModal).subscribe({
      next: (data) => {

        this._config.toastrService.success(this._config.translate.instant('auth.passwordChange'));
        this.dialogRef.close('success');
      }, error: (error) => {
        this._config.showErrors(error);

        this.loading = false;
      }
    })


  }

  validateMatch(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('cPassword')?.value;
    if (pass !== confirmPass && confirmPass.length) {
      group.get('cPassword')?.setErrors({ notMatch: true });
    } else {
      // group.get('cPassword')?.setErrors({ required: true });
    }
  }

  confirmPasswordValidation() {
    this.resetPassForm.controls['cPassword'].valueChanges.subscribe(data => {
      const pass = this.resetPassForm.get('password')?.value;
      if (pass !== data && data.length) {
        this.resetPassForm.get('cPassword')?.setErrors({ notMatch: true });
      }
      else if (!data.length) {
        this.resetPassForm.get('cPassword')?.setErrors({ required: true });
      }
    })

    this.resetPassForm.controls['password'].valueChanges.subscribe(data => {
      const cPassword = this.resetPassForm.get('cPassword')?.value;
      if (cPassword == data) {
        this.resetPassForm.get('cPassword')?.setErrors(null);
      }
      else if (data.length && cPassword?.length && cPassword !== data) {
        this.resetPassForm.get('cPassword')?.setErrors({ notMatch: true });
      }
    })

  }

  hasError(controlName: string, errorName: string) {
    return this.resetPassForm.controls[controlName].hasError(errorName);
  }
}
